"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _select_compact_props = _interopRequireDefault(require("./select_compact_props"));

var _select_props = require("./select_props");

var _panel_component = _interopRequireDefault(require("./component/panel_component"));

var _value_area_string_component = _interopRequireDefault(require("./component/value_area_string_component"));

var _value_area_labels_component = _interopRequireDefault(require("./component/value_area_labels_component"));

var _value_area_img_component = _interopRequireDefault(require("./component/value_area_img_component"));

var _selection_item_component = _interopRequireDefault(require("./component/selection_item_component"));

var _selection_labels_item_component = _interopRequireDefault(require("./component/selection_labels_item_component"));

var _selection_img_item_component = _interopRequireDefault(require("./component/selection_img_item_component"));

var _index = require("./utils/index");

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 转换成数字
var toInt = function toInt(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return parseInt(value, 10) || defaultValue;
}; // 获取元素在页面的top位置


var getElementTop = function getElementTop(element) {
  var result = 0;
  var current;

  if (element) {
    if (typeof element.getBoundingClientRect === 'function') {
      // 用这个方式需要加上滚动条的位置
      result = element.getBoundingClientRect().top;
      result += document.documentElement.scrollTop || document.body.scrollTop;
    } else {
      // 遍历上去
      result = element.offsetTop;
      current = element.offsetParent;

      while (current !== null) {
        result += current.offsetTop;
        current = current.offsetParent;
      }
    }
  }

  return result;
}; // 获取元素在页面上的 left 位置


var getElementLeft = function getElementLeft(element) {
  var actualLeft = element.offsetLeft;
  var curParent = element.offsetParent;

  while (curParent !== null) {
    actualLeft += curParent.offsetLeft;
    curParent = curParent.offsetParent;
  }

  return actualLeft;
}; // 获取元素相当于与当前视口的 top 位置


var getElementViewTop = function getElementViewTop(element) {
  if (element.getBoundingClientRect) {
    return element.getBoundingClientRect().top;
  }

  var offset = element.offsetTop;

  if (element.offsetParent != null) {
    offset += getElementViewTop(element.offsetParent);
  }

  return offset;
}; // 获取元素相对于当前视口的 left 位置


var getElementViewLeft = function getElementViewLeft(element) {
  if (element.getBoundingClientRect) {
    return element.getBoundingClientRect().left;
  }

  var offset = element.offsetLeft;

  if (element.offsetParent != null) {
    offset += getElementViewLeft(element.offsetParent);
  }

  return offset;
}; // 获取元素的高度


var getElementHeight = function getElementHeight(element) {
  var display;
  var position;
  var visibility;
  var result = 0;

  if (element) {
    if (typeof element.getBoundingClientRect === 'function' && element.getBoundingClientRect().height) {
      result = element.getBoundingClientRect().height;
    } else {
      display = element.style.display;
      position = element.style.position;
      visibility = element.style.visibility; // 先展示出来获得高度

      element.style.visibility = 'hidden';
      element.style.display = 'block';
      element.style.position = 'absolute';
      result = element.offsetHeight; // 再还原

      element.style.display = display;
      element.style.position = position;
      element.style.visibility = visibility;
    }
  }

  return result;
}; // 获取元素的宽度


var getElementWidth = function getElementWidth(element) {
  if (element.getBoundingClientRect) {
    return element.getBoundingClientRect().width;
  }

  return element.offsetWidth;
};
/**
 * @class
 */


var Select =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Select, _PureComponent);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleReverseCheckChange", function (event) {
      var isKeyPress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _compactProps = (0, _select_compact_props["default"])(_this.props),
          value = _compactProps.value,
          propsSearchFields = _compactProps.searchFields,
          convertPYs = _compactProps.convertPYs,
          searchCheckAll = _compactProps.searchCheckAll,
          valueFieldName = _compactProps.valueFieldName,
          _compactProps$labelFi = _compactProps.labelFieldName,
          labelFieldName = _compactProps$labelFi === void 0 ? '' : _compactProps$labelFi,
          starMatch = _compactProps.starMatch;

      var searchFields = typeof propsSearchFields === 'undefined' ? [labelFieldName] : propsSearchFields;
      var searchValue = _this.state.searchValue;

      var data = _this.getData();

      var checkAll = _this.isCheckedAll();

      var addValue = function addValue(theValue) {
        if ((0, _spauiUtils.isArray)(result) && (0, _spauiUtils.indexOf)(value, theValue) < 0) {
          result.push(theValue);
        }
      };

      var result = [];

      if (!checkAll) {
        data.map(function (item) {
          if (searchCheckAll) {
            // 搜索排除
            if (!(0, _index.filter)(item, searchValue, searchFields, convertPYs, undefined, starMatch)) {
              return item;
            }
          }

          if (_typeof(item) !== 'object') {
            addValue(item);
          } else {
            if (typeof item.disabled === 'undefined' || !item.disabled) {
              addValue(item[valueFieldName]);
            }
          }

          return item;
        });
      } else {
        // 只清空当前界面的
        if (searchCheckAll) {
          data.map(function (item) {
            // 搜索排除
            if (!(0, _index.filter)(item, searchValue, searchFields, convertPYs, undefined, starMatch)) {
              if ((0, _spauiUtils.indexOf)(value, item) > -1) {
                addValue(item);
              }
            }

            return item;
          });
        }
      } // 之前已经传入了禁用的要加上


      data.map(function (item) {
        if (_typeof(item) === 'object' && item.disabled && (0, _spauiUtils.indexOf)(value, item[valueFieldName]) > -1) {
          addValue(item[valueFieldName]);
        }

        return item;
      });

      _this.handleChange(event, result, true, isKeyPress);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDisplayNumberScroll", function (event) {
      var scrollData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var _this$props = _this.props,
          theNumberOfDisplay = _this$props.theNumberOfDisplay,
          _this$props$displayTi = _this$props.displayTimes,
          displayTimes = _this$props$displayTi === void 0 ? 2 : _this$props$displayTi,
          _this$props$displayIt = _this$props.displayItemHeight,
          displayItemHeight = _this$props$displayIt === void 0 ? 36 : _this$props$displayIt,
          _this$props$data = _this$props.data,
          data = _this$props$data === void 0 ? [] : _this$props$data;
      var scrollTop = scrollData[0] || 0;
      var scrollBottom = scrollData[1] || 0;
      var scrollVisibleHeight = scrollBottom - scrollTop || event.target.clientHeight;
      var dataLength = data.length || 0;
      var getShowBeginIndex = null;
      var theNumberOfDisplayInterval = Math.floor(theNumberOfDisplay / displayTimes);
      var newState = {};
      var lastShowBeginIndex = 0;

      if (theNumberOfDisplayInterval < 2) {
        theNumberOfDisplayInterval = 2;
      }

      if (theNumberOfDisplay > 0 && dataLength > theNumberOfDisplay) {
        // 获取索引数据
        getShowBeginIndex = function getShowBeginIndex() {
          var topSpace = (theNumberOfDisplay - Math.ceil(scrollVisibleHeight / displayItemHeight)) / 2 * displayItemHeight; // 减去可视范围是希望别刚刚好就是顶住scrollTop

          var result = Math.floor((scrollTop - topSpace) / displayItemHeight);

          if (result < 0) {
            result = 0;
          } else if (result > dataLength - theNumberOfDisplay) {
            result = dataLength - theNumberOfDisplay;
          }

          return result;
        }; // 每5个就触发一下开始展示索引


        if (getShowBeginIndex() % theNumberOfDisplayInterval === 0 && lastShowBeginIndex !== getShowBeginIndex()) {
          lastShowBeginIndex = getShowBeginIndex();
          newState = {
            random: "".concat(Math.random()).concat(new Date().getTime()),
            showIndex: lastShowBeginIndex
          };
        }

        _this.setState(newState, function () {
          // 防止滚动条停下的时候，没有触发“每5个就展示的逻辑”
          clearTimeout(_this.scopeScrollTimeout);
          _this.scopeScrollTimeout = setTimeout(function () {
            _this.setState({
              random: "".concat(Math.random()).concat(new Date().getTime()),
              showIndex: getShowBeginIndex()
            });
          }, 10);
        });
      }
    });

    _this.handleSearch = _this.handleSearch.bind(_assertThisInitialized(_this));
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.unClose = _this.unClose.bind(_assertThisInitialized(_this));
    _this.handleCheckAllChange = _this.handleCheckAllChange.bind(_assertThisInitialized(_this));
    _this.documentClick = _this.documentClick.bind(_assertThisInitialized(_this));
    _this.documentKeyDown = _this.documentKeyDown.bind(_assertThisInitialized(_this));
    _this.setDropDownPanelPosition = _this.setDropDownPanelPosition.bind(_assertThisInitialized(_this));
    _this.getDefaultIdLabelData = _this.getDefaultIdLabelData.bind(_assertThisInitialized(_this));
    _this.handleTagsInputKeyDown = _this.handleTagsInputKeyDown.bind(_assertThisInitialized(_this));
    _this.state = {
      open: props.open || false,
      searchValue: props.searchValue || '',
      search: _this.canSearch(props),
      showIndex: 0
    };

    _this.setUnFocus();

    _this.nullList();

    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setDropDownPanelPosition();
      this.updateWindowResize();
      this.updateDocumentClickAndKeyDown();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!(0, _spauiUtils.isUndefined)(nextProps.open)) {
        this.setState({
          open: nextProps.open
        });
      }

      if (!(0, _spauiUtils.isUndefined)(nextProps.searchValue)) {
        this.setState({
          searchValue: nextProps.searchValue
        });
      }

      this.setState({
        search: this.canSearch(nextProps)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setDropDownPanelPosition();
      this.updateWindowResize();
      this.updateDocumentClickAndKeyDown();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeWindowResize();
      this.removeDocumentClickAndKeyDown();
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.domRef = null;
      this.dropdownRef = null;
      this.listRef = null;
    } // 对外提供的data结构的ref，不能去除

  }, {
    key: "getDataRef",
    value: function getDataRef() {
      return this.listRef;
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _compactProps2 = (0, _select_compact_props["default"])(this.props),
          _compactProps2$classN = _compactProps2.classNameMap,
          classNameMap = _compactProps2$classN === void 0 ? {} : _compactProps2$classN;

      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    }
  }, {
    key: "updateDocumentClickAndKeyDown",
    value: function updateDocumentClickAndKeyDown() {
      var _this2 = this;

      var open = this.state.open; // 需要回收

      if (open && !this.haveDocumentClickAndKeyDown) {
        // hack: 这里放到下一个 Event Loop 再去监听，不然在 react 17 下，本次点击展开也会触发 click 事件，导致下拉框无法展开
        setTimeout(function () {
          if (_index.haveJQuery) {
            jQuery(document).on('keydown', _this2.documentKeyDown);
          } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.addEventListener)) {
            document.addEventListener('keydown', _this2.documentKeyDown);
          }

          document.addEventListener('click', _this2.documentClick);
          _this2.haveDocumentClickAndKeyDown = true;
        });
      } else if (!open) {
        this.removeDocumentClickAndKeyDown();
      }
    }
  }, {
    key: "removeDocumentClickAndKeyDown",
    value: function removeDocumentClickAndKeyDown() {
      if (this.haveDocumentClickAndKeyDown) {
        if (_index.haveJQuery) {
          jQuery(document).off('keydown', this.documentKeyDown);
        } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.removeEventListener)) {
          document.removeEventListener('keydown', this.documentKeyDown);
        }

        document.removeEventListener('click', this.documentClick);
        this.haveDocumentClickAndKeyDown = false;
        this._insideClick = false;
      }
    }
  }, {
    key: "documentClick",
    value: function documentClick(event) {
      var open = this.state.open;

      if (this.domRef) {
        if (open && !this._insideClick) {
          this.handleOpen(event);
        }

        this._insideClick = false;
      }
    }
  }, {
    key: "documentKeyDown",
    value: function documentKeyDown(event) {
      var props = this.props;

      var _compactProps3 = (0, _select_compact_props["default"])(this.props),
          valueFieldName = _compactProps3.valueFieldName,
          mode = _compactProps3.mode,
          onSearch = _compactProps3.onSearch;

      var open = this.state.open;
      var data = (0, _index.getShowData)(_objectSpread({}, this.props, {}, this.state));
      var focusIndex = this.focusIndex;
      var keyCode = event.keyCode;
      var result = focusIndex;
      var curData = {};
      var liItem = null;
      var curItem = null;
      var isCheckAll = false;
      var isReverseCheck = false;
      var dataIndex = -1;
      var itemLength = data.length + ((0, _index.isShowCheckAll)(props) ? 1 : 0) + ((0, _index.isShowReverseCheck)(props) ? 1 : 0);

      if (open) {
        if (keyCode === 40) {
          if (focusIndex < itemLength - 1) {
            result = focusIndex + 1;
          } else {
            result = 0;
          }

          event.preventDefault();
        } else if (keyCode === 38) {
          if (focusIndex < 0) {
            result = itemLength - 1;
          } else {
            result = focusIndex - 1;
          }

          event.preventDefault();
        }

        if (result !== focusIndex) {
          this.focusIndex = result;
          this.updateFocus();
        }

        if (keyCode === 13) {
          if (this.listRef) {
            liItem = this.listRef.getElementsByTagName('li');
            curItem = liItem[result];

            if (curItem) {
              isCheckAll = curItem.getAttribute('data-checkall');
              isReverseCheck = curItem.getAttribute('data-reverse-check');
              dataIndex = curItem.getAttribute('data-index');
            }
          }

          curData = data[dataIndex ? dataIndex : result];

          if (result > -1 && curItem && typeof curData !== 'undefined' && (typeof curData.disabled === 'undefined' || !curData.disabled)) {
            if (isCheckAll) {
              this.handleCheckAllChange(event, true);
            } else if (isReverseCheck) {
              this.handleReverseCheckChange(event, true);
            } else {
              this.handleChange(event, _typeof(curData) !== 'object' ? curData : curData[valueFieldName], false, true);
            } // 如果是 tags 模式，选择后，需要清空当前输入的search-input内容


            if (mode === 'tags') {
              if ((0, _spauiUtils.isFunction)(onSearch)) {
                onSearch(event, '');
              }
            }
          }
        }
      } else {
        console.log('unopen');
      }
    }
  }, {
    key: "updateWindowResize",
    value: function updateWindowResize() {
      var open = this.state.open; // 需要回收

      if (open && !this.haveAddWindowResize) {
        if (_index.haveJQuery) {
          jQuery(window).on('resize', this.setDropDownPanelPosition);
        } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
          window.addEventListener('resize', this.setDropDownPanelPosition);
        }

        this.haveAddWindowResize = true;
      } else if (!open) {
        this.removeWindowResize();
      }
    }
  }, {
    key: "removeWindowResize",
    value: function removeWindowResize() {
      if (this.haveAddWindowResize) {
        if (_index.haveJQuery) {
          jQuery(window).off('resize', this.setDropDownPanelPosition);
        } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.removeEventListener)) {
          window.removeEventListener('resize', this.setDropDownPanelPosition);
        }

        this.haveAddWindowResize = false;
      }
    }
  }, {
    key: "getData",
    value: function getData() {
      var _compactProps4 = (0, _select_compact_props["default"])(this.props),
          supplementaryData = _compactProps4.supplementaryData,
          setSupplementaryData = _compactProps4.setSupplementaryData,
          value = _compactProps4.value,
          data = _compactProps4.data,
          multiple = _compactProps4.multiple,
          valueFieldName = _compactProps4.valueFieldName,
          _compactProps4$labelF = _compactProps4.labelFieldName,
          labelFieldName = _compactProps4$labelF === void 0 ? '' : _compactProps4$labelF;

      var getSupplementaryData = function getSupplementaryData(theValue) {
        var result = {};

        if ((0, _spauiUtils.isFunction)(setSupplementaryData)) {
          result = setSupplementaryData(theValue);
        } else {
          result[labelFieldName] = theValue;
          result[valueFieldName] = theValue;
        }

        return result;
      };

      var result = [];
      var valueList = [];
      data.map(function (item) {
        if (_typeof(item) === 'object') {
          valueList.push(item[valueFieldName] || '');
        } else {
          valueList.push(item);
        }

        result.push(item);
        return item;
      });

      if (supplementaryData) {
        // 有可能匹配到的词是不在搜索里面的，所以要加在data里面
        if (multiple) {
          if ((0, _spauiUtils.isArray)(value) && value.length > 0) {
            value.map(function (item) {
              if ((0, _spauiUtils.indexOf)(valueList, item) < 0 && item) {
                result.push(getSupplementaryData(item));
              }

              return item;
            });
          }
        } else {
          if ((0, _spauiUtils.indexOf)(valueList, value) < 0 && value) {
            result.push(getSupplementaryData(value));
          }
        }
      }

      return result;
    } // 是否能够进行搜索

  }, {
    key: "canSearch",
    value: function canSearch() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var search = props.search,
          searchCount = props.searchCount;
      var data = this.getData();
      var result = false; // 如果自己指定了，那肯定用指定的，没有就看看数量

      if (typeof search !== 'undefined') {
        result = search;
      } else if (searchCount > 0 && (0, _spauiUtils.isArray)(data)) {
        result = data.length > searchCount;
      }

      return result;
    } // 是否已经全选

  }, {
    key: "isCheckedAll",
    value: function isCheckedAll() {
      var _compactProps5 = (0, _select_compact_props["default"])(this.props),
          value = _compactProps5.value,
          multiple = _compactProps5.multiple,
          searchCheckAll = _compactProps5.searchCheckAll,
          propsSearchFields = _compactProps5.searchFields,
          convertPYs = _compactProps5.convertPYs,
          starMatch = _compactProps5.starMatch,
          valueFieldName = _compactProps5.valueFieldName,
          _compactProps5$labelF = _compactProps5.labelFieldName,
          labelFieldName = _compactProps5$labelF === void 0 ? '' : _compactProps5$labelF;

      var searchFields = typeof propsSearchFields === 'undefined' ? [labelFieldName] : propsSearchFields;
      var searchValue = this.state.searchValue;
      var data = this.getData();
      var result = true;

      if (multiple && (0, _spauiUtils.isArray)(value) && value.length > 0) {
        data.map(function (item) {
          // 不包括搜索的
          if (searchCheckAll) {
            // 搜索排除
            if (!(0, _index.filter)(item, searchValue, searchFields, convertPYs, undefined, starMatch)) {
              return item;
            }
          }

          if (_typeof(item) !== 'object') {
            // 有选项不在value里面，那就是没有全选
            if (result && (0, _spauiUtils.indexOf)(value, item) < 0) {
              result = false;
            }
          } else {
            // 如果是object的，不算disabled=true在内的
            if (result && (typeof item.disabled === 'undefined' || !item.disabled) && (0, _spauiUtils.indexOf)(value, item[valueFieldName]) < 0) {
              result = false;
            }
          }

          return item;
        });
      } else {
        result = false;
      }

      return result;
    } // 全选回调

  }, {
    key: "handleCheckAllChange",
    value: function handleCheckAllChange(event) {
      var isKeyPress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _compactProps6 = (0, _select_compact_props["default"])(this.props),
          value = _compactProps6.value,
          propsSearchFields = _compactProps6.searchFields,
          convertPYs = _compactProps6.convertPYs,
          searchCheckAll = _compactProps6.searchCheckAll,
          valueFieldName = _compactProps6.valueFieldName,
          _compactProps6$labelF = _compactProps6.labelFieldName,
          labelFieldName = _compactProps6$labelF === void 0 ? '' : _compactProps6$labelF,
          starMatch = _compactProps6.starMatch,
          _compactProps6$stickC = _compactProps6.stickCheckAll,
          stickCheckAll = _compactProps6$stickC === void 0 ? false : _compactProps6$stickC,
          max = _compactProps6.max;

      var searchFields = typeof propsSearchFields === 'undefined' ? [labelFieldName] : propsSearchFields;
      var searchValue = this.state.searchValue;
      var data = this.getData();
      var checkAll = this.isCheckedAll();

      var addValue = function addValue(theValue) {
        if ((0, _spauiUtils.indexOf)(result, theValue) < 0) {
          result.push(theValue);
        }
      };

      var result = [];

      if (!checkAll) {
        // 原来有的补上
        if ((searchCheckAll || stickCheckAll) && (0, _spauiUtils.isArray)(value)) {
          value.map(function (item) {
            addValue(item);
            return item;
          });
        }

        data.map(function (item) {
          if (searchCheckAll) {
            // 搜索排除
            if (!(0, _index.filter)(item, searchValue, searchFields, convertPYs, undefined, starMatch)) {
              return item;
            }
          }

          var canAdd = true;

          if (typeof max !== 'undefined' && max > 0 && stickCheckAll && result.length >= max) {
            canAdd = false;
          }

          if (canAdd) {
            if (_typeof(item) !== 'object') {
              addValue(item);
            } else {
              if (typeof item.disabled === 'undefined' || !item.disabled) {
                addValue(item[valueFieldName]);
              }
            }
          }

          return item;
        });
      } else {
        // 只清空当前界面的
        if (searchCheckAll) {
          data.map(function (item) {
            // 搜索排除
            if (!(0, _index.filter)(item, searchValue, searchFields, convertPYs, undefined, starMatch)) {
              if ((0, _spauiUtils.indexOf)(value, item) > -1) {
                addValue(item);
              }
            }

            return item;
          });
        }
      } // 之前已经传入了禁用的要加上


      data.map(function (item) {
        if (_typeof(item) === 'object' && item.disabled && (0, _spauiUtils.indexOf)(value, item[valueFieldName]) > -1) {
          addValue(item[valueFieldName]);
        }

        return item;
      });
      this.handleChange(event, result, true, isKeyPress);
    } // 反选回调

  }, {
    key: "setDropDownPanelPosition",
    // 设置下拉面板的位置
    value: function setDropDownPanelPosition() {
      var open = this.state.open;

      var _compactProps7 = (0, _select_compact_props["default"])(this.props),
          mountTarget = _compactProps7.mountTarget,
          placement = _compactProps7.placement,
          placementTarget = _compactProps7.placementTarget,
          autoPlacementBasic = _compactProps7.autoPlacementBasic,
          placementAlign = _compactProps7.placementAlign;

      var classNameMap = this.getClassNameMap();
      var selectRect = {};
      var scrollTop = 0;
      var targetRect = {};
      var top = 0;
      var left = 0;
      var width = 0;
      var finalPlacement = placement;
      var dropClassName = [];
      var dropHeight = 0;
      var selectWrapperTop = 0;
      var selectWrapperLeft = 0;
      var singleHeight = 0;
      var documentHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
      var documentWidth = Math.max(document.body.clientWidth, document.documentElement.clientWidth);
      var dropDownStyle = {};
      var parentNode = null; // 面板向上需要添加的className

      var dropTopClassName = classNameMap.SelectDropTopClassName; // 添加面板向上的className

      var addDropTopClassName = function addDropTopClassName() {
        if ((0, _spauiUtils.indexOf)(dropClassName, dropTopClassName) < 0) {
          dropClassName.push(dropTopClassName);
        }
      }; // 去除面板向上的className


      var removeDropTopClassName = function removeDropTopClassName() {
        var dropTopIndex = (0, _spauiUtils.indexOf)(dropClassName, dropTopClassName);

        if (dropTopIndex > -1) {
          dropClassName.splice(dropTopIndex, 1);
        }
      };

      if (this.domRef && this.dropdownRef) {
        // 自动方向
        if (placement === 'auto') {
          // 获取组件的top位置
          selectWrapperTop = getElementTop(this.domRef); // 展示选中内容区域的高度

          singleHeight = getElementHeight(this.domRef); // 获取下拉面板的高度

          dropHeight = getElementHeight(this.dropdownRef);
          dropClassName = (this.dropdownRef.className || '').split(' '); // 如果有指定位置的参照对象的话，页面高度就是知道指定对象的尾部

          if (placementTarget) {
            documentHeight = getElementTop(placementTarget) + getElementHeight(placementTarget);
          } // 如果自动展开的方向是要依据窗口的位置而不是文档流


          if (autoPlacementBasic === 'window') {
            documentHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            selectWrapperTop = getElementViewTop(this.domRef);
          } // 展开下拉面板后碰到或超过页面的高度了


          if (documentHeight <= selectWrapperTop + dropHeight + singleHeight) {
            finalPlacement = 'top';
            addDropTopClassName();
          } else {
            finalPlacement = 'bottom';
            removeDropTopClassName();
          }

          this.dropdownRef.className = dropClassName.join(' ');
        } // 指定了下拉面板的对齐方向


        if (placementAlign) {
          var selectWidth = getElementWidth(this.domRef) || 0;
          var dropWidth = getElementWidth(this.dropdownRef) || 0;

          if (!open) {
            // 下拉框关闭时，需要重置一下 left
            this.dropdownRef.style.left = 'auto';
          } else if (placementAlign === 'left') {
            this.dropdownRef.style.left = '0';
          } else if (placementAlign === 'right') {
            this.dropdownRef.style.left = "".concat(selectWidth - dropWidth, "px");
          } else if (placementAlign === 'auto') {
            // 如果有指定位置的参照对象的话，页面宽度就是到指定对象的右边的宽度
            if (placementTarget) {
              documentWidth = getElementLeft(placementTarget) + getElementWidth(placementTarget);
            } // 如果自动展开的方向是要依据窗口的位置而不是文档流


            if (autoPlacementBasic === 'window') {
              documentWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
              selectWrapperLeft = getElementViewLeft(this.domRef);
            } // 展开面板后碰到或超过页面的宽度


            if (documentWidth <= selectWrapperLeft + dropWidth) {
              this.dropdownRef.style.left = "".concat(selectWidth - dropWidth, "px");
            } else {
              this.dropdownRef.style.left = '0';
            }
          }
        } // 指定了挂载对象


        if (mountTarget === 'body' || _typeof(mountTarget) === 'object' && mountTarget) {
          selectRect = this.domRef.getBoundingClientRect();
          scrollTop = (0, _spauiUtils.getScrollTop)(mountTarget) || 0;

          if (mountTarget === 'body') {
            top = toInt(dropDownStyle.top) + selectRect.top + scrollTop;
            left = toInt(dropDownStyle.left) + selectRect.left;
            width = toInt(selectRect.width);
          } else {
            targetRect = mountTarget.getBoundingClientRect();
            top = toInt(dropDownStyle.top) + selectRect.top - targetRect.top + scrollTop;
            left = toInt(dropDownStyle.left) + selectRect.left - targetRect.left;
            width = toInt(selectRect.width);
          } // 如果不是向上的，还要加上下拉框选项的展示区域的高度


          if (finalPlacement !== 'top') {
            top += toInt(selectRect.height);
          }

          parentNode = this.dropdownRef && this.dropdownRef.parentNode && this.dropdownRef.parentNode.parentNode;

          if (parentNode) {
            parentNode.style.top = "".concat(top, "px");
            parentNode.style.left = "".concat(left, "px");
            parentNode.style.width = "".concat(width, "px");
          }
        }
      }
    }
    /**
     * 获取默认的 id label 数据
     *
     * @memberof Select
     */

  }, {
    key: "getDefaultIdLabelData",
    value: function getDefaultIdLabelData() {
      var _compactProps8 = (0, _select_compact_props["default"])(this.props),
          propsValue = _compactProps8.value,
          valueFieldName = _compactProps8.valueFieldName,
          labelFieldName = _compactProps8.labelFieldName;

      var theValue = [];
      var result = [];

      if ((0, _spauiUtils.isArray)(propsValue)) {
        theValue = propsValue;
      } else {
        theValue = [propsValue];
      }

      theValue.forEach(function (itemValue) {
        if (!(0, _spauiUtils.isEmptyValue)(itemValue)) {
          var _result$push;

          result.push((_result$push = {}, _defineProperty(_result$push, valueFieldName, itemValue), _defineProperty(_result$push, labelFieldName, itemValue), _result$push));
        }
      });
      return result;
    }
    /**
     * 获取value对应的数据
     * @private
     */

  }, {
    key: "getValueDataMap",
    value: function getValueDataMap(customValue) {
      var _compactProps9 = (0, _select_compact_props["default"])(this.props),
          propsValue = _compactProps9.value,
          multiple = _compactProps9.multiple,
          _compactProps9$labelD = _compactProps9.labelData,
          labelData = _compactProps9$labelD === void 0 ? [] : _compactProps9$labelD,
          valueDataMap = _compactProps9.valueDataMap,
          valueFieldName = _compactProps9.valueFieldName,
          searchValueData = _compactProps9.searchValueData;

      var data = this.getData();
      var searchValueList = searchValueData; // searchValueData目前是object，只支持一个需要转成数组

      if (searchValueList && !(0, _spauiUtils.isArray)(searchValueList)) {
        searchValueList = [searchValueList];
      }

      var value = typeof customValue !== 'undefined' ? customValue : propsValue;

      var addMap = function addMap() {
        var theData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        theData.map(function (item) {
          if (multiple) {
            if ((0, _spauiUtils.isArray)(value)) {
              value.map(function (subValue) {
                if ((0, _index.isEqual)(item, valueFieldName, subValue)) {
                  result[subValue] = item;
                }

                return subValue;
              });
            }
          } else {
            if ((0, _index.isEqual)(item, valueFieldName, value)) {
              result[value] = item;
            }
          }

          return item;
        });
      };

      var result = {}; // 自己指定了valueDataMap就优先使用

      if (_typeof(valueDataMap) === 'object' && valueDataMap) {
        result = valueDataMap;
      } else {
        // 先添加 id label 的数据，如果 data 或 labelData 中有对应的数据，则下面会进行覆盖
        addMap(this.getDefaultIdLabelData()); // 防止value有一些数据已不在data里面，所以可以传labelData

        addMap(labelData); // 再添加下自定义搜索的结果

        addMap(searchValueList || []); // data数据

        addMap(data);
      } // 如果没有匹配中，那就是用原始值


      if (!multiple && (typeof propsValue === 'number' || propsValue) && (0, _spauiUtils.isEmptyObject)(result)) {
        result[propsValue] = propsValue;
      }

      return result;
    } // 获取选项组件

  }, {
    key: "getItemComponent",
    value: function getItemComponent() {
      var _compactProps10 = (0, _select_compact_props["default"])(this.props),
          propsSelectionItemComponent = _compactProps10.SelectionItemComponent,
          _compactProps10$showS = _compactProps10.showSelectionLabelsItemComponent,
          showSelectionLabelsItemComponent = _compactProps10$showS === void 0 ? false : _compactProps10$showS,
          _compactProps10$showS2 = _compactProps10.showSelectionImgItemComponent,
          showSelectionImgItemComponent = _compactProps10$showS2 === void 0 ? false : _compactProps10$showS2;

      var _getTheSignOfTheItemC = (0, _index.getTheSignOfTheItemComponent)(this.getData(), (0, _select_compact_props["default"])(this.props)),
          haveLabel = _getTheSignOfTheItemC.haveLabel,
          haveDescription = _getTheSignOfTheItemC.haveDescription,
          haveImg = _getTheSignOfTheItemC.haveImg;

      var result = null;

      if (typeof propsSelectionItemComponent !== 'undefined' && propsSelectionItemComponent) {
        result = propsSelectionItemComponent;
      } else {
        if (showSelectionLabelsItemComponent) {
          // 有指定的就走指定的
          result = _selection_labels_item_component["default"];
        } else if (showSelectionImgItemComponent) {
          // 有指定的就走指定的
          result = _selection_img_item_component["default"];
        } else if (haveLabel && haveDescription) {
          result = _selection_labels_item_component["default"];
        } else if (haveImg) {
          result = _selection_img_item_component["default"];
        } else {
          result = _selection_item_component["default"];
        }
      }

      return result;
    } // 获取展示区域组件

  }, {
    key: "getValueAreaComponent",
    value: function getValueAreaComponent() {
      var _compactProps11 = (0, _select_compact_props["default"])(this.props),
          ValueAreaComponent = _compactProps11.ValueAreaComponent,
          valueAreaType = _compactProps11.valueAreaType,
          multiple = _compactProps11.multiple,
          mode = _compactProps11.mode,
          _compactProps11$showL = _compactProps11.showLabelAreaType,
          showLabelAreaType = _compactProps11$showL === void 0 ? false : _compactProps11$showL,
          _compactProps11$showI = _compactProps11.showImgAreaType,
          showImgAreaType = _compactProps11$showI === void 0 ? false : _compactProps11$showI;

      var _getTheSignOfTheItemC2 = (0, _index.getTheSignOfTheItemComponent)(this.getData(), (0, _select_compact_props["default"])(this.props)),
          haveImg = _getTheSignOfTheItemC2.haveImg;

      var open = this.state.open;
      var result = null; // 外部指定了头部

      if (typeof ValueAreaComponent !== 'undefined' && ValueAreaComponent) {
        result = ValueAreaComponent;
      } else {
        // 根据指定的类型以及数据选择用哪个模式展示
        if (valueAreaType === 'labels' && open && multiple || showLabelAreaType && multiple || mode === 'tags') {
          result = _value_area_labels_component["default"];
        } else if ((haveImg || showImgAreaType) && !multiple) {
          result = _value_area_img_component["default"];
        } else {
          result = _value_area_string_component["default"];
        }
      }

      return result;
    }
    /**
     * tags 模式下，search input 的 keyDown 回调函数
     * @param {*} event
     */

  }, {
    key: "handleTagsInputKeyDown",
    value: function handleTagsInputKeyDown(event) {
      var _compactProps12 = (0, _select_compact_props["default"])(this.props),
          enabledDeleteKey = _compactProps12.enabledDeleteKey,
          value = _compactProps12.value,
          onChange = _compactProps12.onChange,
          onSearchKeyDown = _compactProps12.onSearchKeyDown;

      var searchValue = this.state.searchValue;
      var key = event.keyCode || event.charCode; // 当前输入框中的值是空字符串，并且现在按的是删除按钮, 则删除当前选中值的最后一项

      if ((key == 8 || key == 46) && enabledDeleteKey && searchValue === '' && (0, _spauiUtils.isArray)(value) && value.length > 0 && (0, _spauiUtils.isFunction)(onChange)) {
        var result = value.slice(0, value.length - 1);
        onChange(event, result, (0, _spauiUtils.objectAssign)(this.getValueDataMap(result)), true);
      }

      if ((0, _spauiUtils.isFunction)(onSearchKeyDown)) {
        onSearchKeyDown(event, searchValue);
      }
    }
    /**
     * 展开回调
     */

  }, {
    key: "handleOpen",
    value: function handleOpen(event, nextOpenStatus) {
      var _compactProps13 = (0, _select_compact_props["default"])(this.props),
          propsOpen = _compactProps13.open,
          onOpen = _compactProps13.onOpen,
          disabled = _compactProps13.disabled;

      var open = this.state.open;
      var result = (0, _spauiUtils.isUndefined)(nextOpenStatus) ? !open : nextOpenStatus; // 禁用不能点击

      if (!disabled) {
        if ((0, _spauiUtils.isFunction)(onOpen)) {
          onOpen(event, result);
        }

        this.setUnFocus(); // 如果外部不设置的话，就内部维护一个

        if ((0, _spauiUtils.isUndefined)(propsOpen)) {
          this.setState({
            open: result
          });
        }
      }
    } // 声明是内部点击，不进行关闭

  }, {
    key: "unClose",
    value: function unClose() {
      this._insideClick = true;
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _compactProps14 = (0, _select_compact_props["default"])(this.props),
          onClick = _compactProps14.onClick; // 已经监听了页面点击的话，点击就不关闭了


      if (this.haveDocumentClickAndKeyDown) {
        this.unClose();
      }

      if ((0, _spauiUtils.isFunction)(onClick)) {
        onClick(event);
      }
    } // 值是否相同

  }, {
    key: "isSameValue",
    value: function isSameValue(newValue) {
      var _compactProps15 = (0, _select_compact_props["default"])(this.props),
          lastValue = _compactProps15.value;

      var result = false;

      if (newValue === lastValue) {
        result = true;
      } else if ((0, _spauiUtils.isArray)(newValue) && (0, _spauiUtils.isArray)(lastValue) && newValue.length === lastValue.length) {
        result = true;
        newValue.map(function (item) {
          if ((0, _spauiUtils.indexOf)(lastValue, item) < 0) {
            result = false;
          }

          return item;
        });
      }

      return result;
    }
    /**
     * 变更值回调
     */

  }, {
    key: "handleChange",
    value: function handleChange(event, value) {
      var isResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var isKeyPress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var triggerOnOpen = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      var _compactProps16 = (0, _select_compact_props["default"])(this.props),
          onChange = _compactProps16.onChange,
          multiple = _compactProps16.multiple,
          propsValue = _compactProps16.value,
          disabled = _compactProps16.disabled,
          closeWhenTheValueChange = _compactProps16.closeWhenTheValueChange,
          sameValueNotTriggerChange = _compactProps16.sameValueNotTriggerChange,
          searchValue = _compactProps16.searchValue,
          clearSearchValueWhenChange = _compactProps16.clearSearchValueWhenChange;

      var result = '';
      var index = -1;
      var triggerChange = true; // 禁用不能点击

      if (!disabled) {
        if (isResult) {
          result = value;
        } else {
          if (multiple) {
            result = [];

            if ((0, _spauiUtils.isArray)(propsValue)) {
              index = (0, _spauiUtils.indexOf)(propsValue, value);
              propsValue.map(function (item) {
                result.push(item);
                return item;
              });
            }

            if (index < 0) {
              result.push(value);
            } else {
              result.splice(index, 1);
            }
          } else {
            result = value;
          }
        }

        if ((0, _spauiUtils.isFunction)(onChange)) {
          // 值一样就不触发onChange
          if (sameValueNotTriggerChange && this.isSameValue(result)) {
            triggerChange = false;
          }

          if (triggerChange) {
            onChange(event, result, (0, _spauiUtils.objectAssign)(this.getValueDataMap(result)), isKeyPress); // 如果外面没有传 searchValue，那么则要看看当前是否要清空 searchValue

            if (clearSearchValueWhenChange && typeof searchValue === 'undefined') {
              this.setState({
                searchValue: ''
              });
            }
          }
        } // 单选，点击就关闭


        if (!multiple && closeWhenTheValueChange && triggerOnOpen) {
          this.handleOpen(event);
        }
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(event) {
      var _compactProps17 = (0, _select_compact_props["default"])(this.props),
          onSearch = _compactProps17.onSearch,
          searchValue = _compactProps17.searchValue;

      var result = event.target.value;

      if (typeof searchValue === 'undefined') {
        this.setState({
          searchValue: result
        });
      }

      if ((0, _spauiUtils.isFunction)(onSearch)) {
        onSearch(event, result);
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(event) {
      var scrollTop = event.target.scrollTop;
      var visibleHeight = event.target.clientHeight;
      var scrollHeight = event.target.scrollHeight;

      var _compactProps18 = (0, _select_compact_props["default"])(this.props),
          onScroll = _compactProps18.onScroll;

      this.handleDisplayNumberScroll(event, [scrollTop, scrollTop + visibleHeight], scrollHeight, 0);

      if ((0, _spauiUtils.isFunction)(onScroll)) {
        onScroll(event, [scrollTop, scrollTop + visibleHeight], scrollHeight);
      }
    } // 把选中的焦点去除

  }, {
    key: "setUnFocus",
    value: function setUnFocus() {
      this.focusIndex = -1;
      this.updateFocus();
    }
  }, {
    key: "updateFocus",
    value: function updateFocus() {
      var focusIndex = this.focusIndex;

      var removeFocusClassName = function removeFocusClassName() {
        var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var result = [];
        var classNameArr = [];
        classNameArr = className.split(' ');
        classNameArr.map(function (item) {
          if (item !== 'focus') {
            result.push(item);
          }

          return item;
        });
        return result.join(' ');
      };

      var liItem = null;
      var i = 0;
      var len = 0;
      var dataClientRect = {};
      var itemClientRect = {};

      if (this.listRef) {
        liItem = this.listRef.getElementsByTagName('li'); // 先全部出去focus class

        i = 0;
        len = liItem.length;

        for (; i < len; i++) {
          if (liItem[i]) {
            liItem[i].className = removeFocusClassName(liItem[i].className);
          }
        }

        if (focusIndex > -1 && liItem[focusIndex]) {
          liItem[focusIndex].className = "".concat(removeFocusClassName(liItem[focusIndex].className), " focus");
          dataClientRect = this.listRef.getBoundingClientRect();
          itemClientRect = liItem[focusIndex].getBoundingClientRect();

          if (itemClientRect.height * (focusIndex + 1) - dataClientRect.height >= 0) {
            this.listRef.scrollTop = itemClientRect.height * (focusIndex + 1) - dataClientRect.height;
          } else {
            this.listRef.scrollTop = 0;
          }
        }
      }
    } // 获取第二层容器div的className

  }, {
    key: "getContainerClassName",
    value: function getContainerClassName() {
      var _classNames;

      var _compactProps19 = (0, _select_compact_props["default"])(this.props),
          tip = _compactProps19.tip,
          loading = _compactProps19.loading,
          valueAreaType = _compactProps19.valueAreaType,
          _compactProps19$showL = _compactProps19.showLabelAreaType,
          showLabelAreaType = _compactProps19$showL === void 0 ? false : _compactProps19$showL,
          multiple = _compactProps19.multiple,
          value = _compactProps19.value,
          _compactProps19$conta = _compactProps19.containerClassName,
          propsContainerClassName = _compactProps19$conta === void 0 ? '' : _compactProps19$conta,
          mode = _compactProps19.mode,
          SelectionTipComponent = _compactProps19.SelectionTipComponent,
          _compactProps19$showT = _compactProps19.showTip,
          showTip = _compactProps19$showT === void 0 ? true : _compactProps19$showT;

      var _this$state = this.state,
          search = _this$state.search,
          open = _this$state.open;
      var data = this.getData();
      var classNameMap = this.getClassNameMap();
      return (0, _classnames["default"])(propsContainerClassName, classNameMap.SelectContainerClassName, (_classNames = {}, _defineProperty(_classNames, classNameMap.SelectContainerOpenClassName, open), _defineProperty(_classNames, classNameMap.SelectContainerWithTipsClassName, (data.length < 1 || tip) && !loading && showTip), _defineProperty(_classNames, classNameMap.SelectContainerWithSearchLoadingClassName, search && loading), _defineProperty(_classNames, classNameMap.SelectContainerWithSearchClassName, search), _defineProperty(_classNames, classNameMap.SelectContainerWithLabelsClassName, valueAreaType === 'labels' && (multiple ? value.length > 0 : false) && open || showLabelAreaType && (multiple ? value.length > 0 : false)), _defineProperty(_classNames, classNameMap.SelectContainerWithTagsClassName, mode === 'tags'), _defineProperty(_classNames, 'with-custom-tips', SelectionTipComponent), _defineProperty(_classNames, 'with-list-loading', loading), _classNames));
    } // 获取通用属性

  }, {
    key: "getGlobalProps",
    value: function getGlobalProps() {
      var _classNames2;

      var _compactProps20 = (0, _select_compact_props["default"])(this.props),
          disabled = _compactProps20.disabled,
          mountTarget = _compactProps20.mountTarget,
          headless = _compactProps20.headless,
          theme = _compactProps20.theme,
          underline = _compactProps20.underline,
          valueGap = _compactProps20.valueGap,
          useValueFlex = _compactProps20.useValueFlex,
          _compactProps20$size = _compactProps20.size,
          size = _compactProps20$size === void 0 ? 'default' : _compactProps20$size,
          valuePrefix = _compactProps20.valuePrefix,
          valueSuffix = _compactProps20.valueSuffix;

      var classNameMap = this.getClassNameMap();
      var open = this.state.open;
      return (0, _spauiUtils.globalProps)((0, _select_compact_props["default"])(this.props), {
        className: (0, _classnames["default"])(classNameMap.Select, (_classNames2 = {
          disabled: disabled
        }, _defineProperty(_classNames2, classNameMap.SelectOpenByComponentClassName, open && (!mountTarget || mountTarget === 'component')), _defineProperty(_classNames2, classNameMap.SelectOpenClassName, open), _defineProperty(_classNames2, "headless", headless), _defineProperty(_classNames2, "underline", underline), _defineProperty(_classNames2, 'use-value-flex', useValueFlex || valueGap || valuePrefix || valueSuffix), _defineProperty(_classNames2, "spaui-select-".concat(size), !['default', 'middle'].includes(size)), _classNames2), theme),
        events: ['onClick']
      }, Select);
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      var _objectSpread2;

      var _this$props2 = this.props,
          style = _this$props2.style,
          width = _this$props2.width,
          minWidth = _this$props2.minWidth,
          maxWidth = _this$props2.maxWidth,
          height = _this$props2.height,
          lineHeight = _this$props2.lineHeight,
          valuePadding = _this$props2.valuePadding,
          valueBorder = _this$props2.valueBorder,
          valueBg = _this$props2.valueBg,
          valueGap = _this$props2.valueGap,
          valueFontSize = _this$props2.valueFontSize,
          dropWidth = _this$props2.dropWidth,
          dropMinWidth = _this$props2.dropMinWidth,
          dropMaxWidth = _this$props2.dropMaxWidth,
          dropOffsetY = _this$props2.dropOffsetY,
          infoPadding = _this$props2.infoPadding,
          infoHeight = _this$props2.infoHeight,
          infoLineHeight = _this$props2.infoLineHeight,
          searchHeight = _this$props2.searchHeight,
          resultsPadding = _this$props2.resultsPadding,
          resultsMaxHeight = _this$props2.resultsMaxHeight,
          itemTitleWidth = _this$props2.itemTitleWidth;
      var ret = (0, _spauiUtils.removeUndefined)(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, '--select-value-p', valuePadding), _defineProperty(_objectSpread2, '--select-value-w', (0, _spauiUtils.pxVal)(width)), _defineProperty(_objectSpread2, '--select-value-min-w', (0, _spauiUtils.pxVal)(minWidth)), _defineProperty(_objectSpread2, '--select-value-max-w', (0, _spauiUtils.pxVal)(maxWidth)), _defineProperty(_objectSpread2, '--select-value-h', (0, _spauiUtils.pxVal)(height)), _defineProperty(_objectSpread2, '--select-value-lh', (0, _spauiUtils.pxVal)(lineHeight)), _defineProperty(_objectSpread2, '--select-info-height', (0, _spauiUtils.pxVal)(infoHeight)), _defineProperty(_objectSpread2, '--select-info-line-height', (0, _spauiUtils.pxVal)(infoLineHeight)), _defineProperty(_objectSpread2, '--select-drop-w', (0, _spauiUtils.pxVal)(dropWidth)), _defineProperty(_objectSpread2, '--select-drop-min-w', (0, _spauiUtils.pxVal)(dropMinWidth)), _defineProperty(_objectSpread2, '--select-drop-max-w', (0, _spauiUtils.pxVal)(dropMaxWidth)), _defineProperty(_objectSpread2, '--select-drop-offset-y', (0, _spauiUtils.pxVal)(dropOffsetY)), _defineProperty(_objectSpread2, '--select-info-p', infoPadding), _defineProperty(_objectSpread2, '--select-value-bg', valueBg), _defineProperty(_objectSpread2, '--select-value-border', valueBorder), _defineProperty(_objectSpread2, '--select-value-gap', (0, _spauiUtils.pxVal)(valueGap)), _defineProperty(_objectSpread2, '--select-results-p', resultsPadding), _defineProperty(_objectSpread2, '--select-results-max-h', (0, _spauiUtils.pxVal)(resultsMaxHeight)), _defineProperty(_objectSpread2, '--select-search-h', (0, _spauiUtils.pxVal)(searchHeight)), _defineProperty(_objectSpread2, '--select-value-fs', (0, _spauiUtils.pxVal)(valueFontSize)), _defineProperty(_objectSpread2, '--select-item-title-width', (0, _spauiUtils.pxVal)(itemTitleWidth)), _objectSpread2), style));
      return ret;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _compactProps21 = (0, _select_compact_props["default"])(this.props),
          containerStyle = _compactProps21.containerStyle,
          portalStyle = _compactProps21.portalStyle,
          mountTarget = _compactProps21.mountTarget,
          mountTargetClassName = _compactProps21.mountTargetClassName,
          SelectionAreaComponent = _compactProps21.SelectionAreaComponent,
          _compactProps21$compa = _compactProps21.compactOldSelect,
          compactOldSelect = _compactProps21$compa === void 0 ? false : _compactProps21$compa,
          _compactProps21$disab = _compactProps21.disabled,
          disabled = _compactProps21$disab === void 0 ? false : _compactProps21$disab,
          _compactProps21$show = _compactProps21.show,
          show = _compactProps21$show === void 0 ? true : _compactProps21$show;

      var _this$state2 = this.state,
          searchValue = _this$state2.searchValue,
          search = _this$state2.search,
          open = _this$state2.open;
      var data = this.getData();
      var globalPropsData = this.getGlobalProps();
      var containerClassName = this.getContainerClassName();
      var ValueAreaComponent = this.getValueAreaComponent();
      var classNameMap = this.getClassNameMap();

      var commonProps = _objectSpread({
        open: open,
        onOpen: this.handleOpen,
        onChange: this.handleChange,
        onClick: this.handleClick,
        showIndex: this.state.showIndex
      }, (0, _index.getTheSignOfTheItemComponent)(data, (0, _select_compact_props["default"])(this.props)));

      var dataMap = this.getValueDataMap();
      var showPanel = !(disabled && !open); // 如果是禁用且不打开的话，就不渲染下拉面板结构了

      var valueAreaComponentProps = {};
      var oldSelectValueAreaData = [];
      var key = '';

      if (!show) {
        return null;
      }

      if (compactOldSelect) {
        valueAreaComponentProps.onClick = function (e) {
          if ((0, _spauiUtils.isFunction)(commonProps.onOpen)) {
            commonProps.onOpen(e);
          }

          if ((0, _spauiUtils.isFunction)(commonProps.onClick)) {
            commonProps.onClick(e);
          }
        };

        if (dataMap && _typeof(dataMap) === 'object') {
          for (key in dataMap) {
            if (dataMap[key] || typeof dataMap[key] === 'number') {
              oldSelectValueAreaData.push(dataMap[key]);
            }
          }
        }

        valueAreaComponentProps.data = oldSelectValueAreaData;
      }

      var checkAllIsChecked = this.isCheckedAll();
      return _react["default"].createElement("div", _extends({}, globalPropsData, {
        ref: function ref(el) {
          _this3.domRef = el;
        },
        style: this.getStyles()
      }), _react["default"].createElement("div", {
        className: containerClassName,
        style: containerStyle
      }, _react["default"].createElement(ValueAreaComponent, _extends({}, (0, _select_compact_props["default"])(this.props), commonProps, {
        classNameMap: classNameMap,
        data: dataMap,
        checkAllIsChecked: checkAllIsChecked,
        unClose: this.unClose,
        searchValue: searchValue,
        onSearch: this.handleSearch,
        handleTagsInputKeyDown: this.handleTagsInputKeyDown,
        onSearchInputFocus: this.onSearchInputFocus,
        onSearchInputBlur: this.onSearchInputBlur
      }, valueAreaComponentProps)), _react["default"].createElement(_panel_component["default"], {
        portalClassName: (0, _classnames["default"])(globalPropsData.className, mountTargetClassName),
        mountTarget: mountTarget,
        containerClassName: containerClassName,
        containerStyle: containerStyle,
        show: showPanel,
        portalStyle: portalStyle
      }, _react["default"].createElement(SelectionAreaComponent, _extends({}, (0, _select_compact_props["default"])(this.props), commonProps, {
        classNameMap: classNameMap,
        data: data,
        SelectionItemComponent: this.getItemComponent(),
        onCheckAllChange: this.handleCheckAllChange,
        checkAllIsChecked: checkAllIsChecked,
        onReverseCheckChange: this.handleReverseCheckChange,
        search: search,
        searchValue: searchValue,
        onSearch: this.handleSearch,
        onScroll: this.handleScroll,
        dropDownHtmlRef: function dropDownHtmlRef(el) {
          _this3.dropdownRef = el;
        },
        dataHtmlRef: function dataHtmlRef(el) {
          _this3.listRef = el;
        },
        unClose: this.unClose
      })))));
    }
  }]);

  return Select;
}(_react.PureComponent); // 组件标记


_defineProperty(Select, "propTypes", _select_props.propTypes);

_defineProperty(Select, "defaultProps", _select_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Select, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Select;
exports["default"] = _default;